import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { AppRoutes } from 'types';
import EditAssignmentContainer from './components/EditAssignmentContainer';
import EditAssignmentFooter from './components/EditAssignmentFooter';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import { isTrialLicense } from '@monorepo/shared/src/graph/selectors/license-selector';

const t = (key, options?) => translate('assignment', key, options);

const EditAssignment: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const omitRoutes = useTrialUserOmitRoutes();
  const letter = params?.letter;
  const letters = `${letter?.toUpperCase()}${letter?.toLowerCase()}`;

  const [{ me }] = useUserStore();
  const license = me?.licenses?.[0];
  const isTrialUser = isTrialLicense(license);
  if (isTrialUser) navigate('/home');

  return (
    <>
      <SectionHeader
        omitRoutes={omitRoutes}
        backRoute={`/${AppRoutes.ASSIGNMENTS}`}
        title={t('editAssignmentTitle', {
          letters,
        })}
      />
      <EditAssignmentContainer />
      <EditAssignmentFooter />
    </>
  );
};

export default EditAssignment;
